<template>
  <div class="vue-select-utility-dropdown-wrap">
    <!-- <div v-if="utilitesForDropdown">
        <select @change="onUtilitySelectChange($event)" name="utilites">
          <option v-for="utility in utilitesForDropdown" v-bind:selected="utility.selected" :key="utility.utilityId" :value="utility.utilityId">{{utility.name}}</option>
        </select>
    </div> -->
    <!-- START - if user is not authorized to edit any utilities -->
    <div
    v-if="utilites && !utilites.length"
    class="controls-container utility-select">
      <label for="utility">You are not authorized to upload utility outages.</label>
    </div>
    <!-- END - if user is not authorized to edit any utilities -->
    <!-- START - if user is authorized to edit more than one utility -->
    <div
    v-if="utilites && utilites.length && utilites.length > 1"
    class="controls-container utility-select">
      <select @change="onUtilitySelectChange($event)" name="utilites">
        <option v-for="utility in utilitesForDropdown" :key="utility.name" :value="utility.code">{{utility.name}}</option>
      </select>
    </div>
    <!-- END - if user is authorized to edit more than one utility -->
  </div>
</template>

<script>
import lodash from 'lodash';
const placeholderUtilityId = 999;

export default {
  name: 'SelectUtilityDropdown',
  props: {
    utilites: Array,
    utilitySelected: Function
  },
  data() {
    return {
      utilitesForDropdown: undefined,
      placeholderUtility: {
        utilityId: placeholderUtilityId,
        name: 'Please select a utility',
        selected: true
      }
    }
  },
  async created() {
    this.processUtilitesForDropdown(this.utilites);
  },
  watch: {
    utilites: function (utilites) {this.processUtilitesForDropdown(utilites); }
  },
  methods: {
    onUtilitySelectChange(event) {
      const utilityCode = event.target.value;
      const matchingUtility = lodash.find(this.utilitesForDropdown, utility => utility.code === utilityCode);
      this.utilitySelected(matchingUtility);
    },
    processUtilitesForDropdown(utilites) {
      this.utilitesForDropdown = [this.placeholderUtility];
      setTimeout(() => {
        this.utilitesForDropdown = JSON.parse(JSON.stringify(utilites));
        this.utilitesForDropdown.unshift(this.placeholderUtility);
      }, 5);
    }
  }
}
</script>
<style lang="scss" scoped>
.vue-select-utility-dropdown-wrap{
  .controls-container{
    label{
      margin-right: 10px;
      font-weight: bold;
    }
  }
}
</style>
